import { useEffect, useState } from "react";
import { BACKEND_URL } from "../config";
import { Link, useNavigate } from "react-router-dom";
import { safeGetItem } from "../utils/storage";

export default function Wishlist() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const token = safeGetItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    const load = async () => {
      try {
        const res = await fetch(`${BACKEND_URL}/wishlist`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const data = await res.json();
        setItems(Array.isArray(data) ? data : []);
      } catch (err) {
        console.error("Wishlist load error", err);
      }
    };

    load();
  }, [navigate]);

  const removeItem = async (id) => {
    const token = safeGetItem("token");
    if (!token) {
      navigate("/login");
      return;
    }

    try {
      await fetch(`${BACKEND_URL}/wishlist/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      setItems((prev) => prev.filter((i) => i._id !== id));
    } catch (err) {
      console.error("Wishlist delete error", err);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-blue-100 p-6">
      <h2 className="text-3xl font-bold text-center text-blue-700 mb-6">
        Your Wishlist
      </h2>

      {items.length === 0 ? (
        <p className="text-center text-gray-600">
          No items in wishlist yet. Browse{" "}
          <Link className="text-blue-600 underline" to="/consultancies">
            consultancies
          </Link>{" "}
          and add some!
        </p>
      ) : (
        <div className="max-w-4xl mx-auto space-y-4">
          {items.map((item) => (
            <div
              key={item._id}
              className="bg-white p-4 rounded-xl shadow flex justify-between items-center"
            >
              <div>
                <h3 className="text-lg font-semibold">
                  {item.consultancy?.name || "Consultancy"}
                </h3>
                <p className="text-gray-600 text-sm">
                  {item.consultancy?.email}
                </p>
              </div>

              <div className="flex items-center space-x-3">
                <Link
                  to={`/consultancy/${item.consultancy?._id}`}
                  className="px-3 py-1 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-700"
                >
                  View
                </Link>
                <button
                  onClick={() => removeItem(item._id)}
                  className="px-3 py-1 rounded-lg bg-red-500 text-white text-sm hover:bg-red-600"
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
